// extracted by mini-css-extract-plugin
module.exports = {"root":"_2d1addab","tableWrapper":"_4c2e5ff6","responsiveEmbed":"_7aad9485","iconLink":"_5b98d1e8"};